import type { CustomerType } from '@/api/reservations/types';
import { Chip, ChipType } from '@/ui/chip';
import { Tooltip } from '@/ui/tooltip';

const CUSTOMER_TYPE_CONTENT: Record<
  CustomerType,
  { label: string; chipType: ChipType; tooltip: string }
> = {
  eon: {
    label: 'Eon',
    chipType: ChipType.DEFAULT,
    tooltip:
      'Eon customer\nTheir first rental with you came through Eon. You earn the standard rate.',
  },
  eon_via_portal: {
    label: 'Eon via portal',
    chipType: ChipType.DEFAULT,
    tooltip:
      'Eon customer, booked on your portal\nThis reservation was made on your EonOne portal, but their first rental with you came through Eon. You earn the standard rate.',
  },
  direct: {
    label: 'Direct',
    chipType: ChipType.BRAND,
    tooltip: 'Direct customer\nYour own customer. You earn the EonOne rate.',
  },
};

export const CustomerTypeChip = ({ type }: { type: CustomerType }) => {
  const { label, chipType, tooltip } = CUSTOMER_TYPE_CONTENT[type];

  return (
    <Tooltip text={tooltip} openOnHover>
      <Chip type={chipType} text={label} />
    </Tooltip>
  );
};
